import { useCallback } from 'react';

interface EventProps {
  action: string;
  category: string;
  label?: string;
  value?: number;
}

export const useAnalytics = () => {
  const trackEvent = useCallback(({ action, category, label, value }: EventProps) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'custom_event',
        eventAction: action,
        eventCategory: category,
        eventLabel: label,
        eventValue: value,
      });
    }
  }, []);

  const trackPageView = useCallback((path: string) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: path,
      });
    }
  }, []);

  const trackConversion = useCallback((type: 'lead' | 'demo', value?: number) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'conversion',
        conversionType: type,
        conversionValue: value,
      });
    }
  }, []);

  return { trackEvent, trackPageView, trackConversion };
};